import * as Common from "../../commons/common"

export class Sheet {
  id: number
  exec_date: string
  name: string
  curriculum_id: number
  curriculum_name: string
  subject_name: string
  digital_sheet_published: boolean
  result_published: boolean
  result_image_published: boolean
  is_uploaded: boolean
  student_no: number
  url: string
  answer_limit: string = "-"
  is_disp_correct_question_image: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.exec_date = Common.formatDate(sheet.exec_date, "Y年M月D日");
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.curriculum_name = sheet.curriculum_name;
    this.subject_name = sheet.subject_name;
    this.digital_sheet_published = sheet.digital_sheet_published;
    this.result_published = sheet.result_published;
    this.result_image_published = sheet.result_image_published;
    this.is_uploaded = sheet.is_uploaded;
    this.student_no = sheet.student_no;
    this.url = sheet.url;
    this.is_disp_correct_question_image = sheet.is_disp_correct_question_image;
    if(sheet.test_start_datetime_at && sheet.test_end_datetime_at){
      this.answer_limit = `${Common.formatDate(sheet.test_start_datetime_at, "M月D日 HH:mm")} 〜 ${Common.formatDate(sheet.test_end_datetime_at, "M月D日 HH:mm")}`;
    }
  }
}